import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

const BarGraphSubjectWise = ( { data, filter } ) => {

    let nameArray = [];
    let scoreArray = [];

    for (let i = 0; i < data.length; i++) {
    
      //console.log(data[i].username);
      //console.log(filter);
      if (data[i].subject === filter) {
      nameArray.push(data[i].username);
      scoreArray.push(data[i].score);
      }
    }
    //console.log(scoreArray);
    const state = {
      labels: nameArray,
      datasets: [
        {
          label: "Results",
          backgroundColor: "rgba(100,200,300,1)",
          borderColor: "rgba(0,0,0,1)",
          borderWidth: 2,
          data: scoreArray,
        },
      ],
    };
    return (
      <div>
        <Bar
          data={state}
          options={{
            title: {
              display: true,
              text: "Results",
              fontSize: 20,
            },
            legend: {
              display: true,
              position: "right",
            },
          }}
        />
      </div>
    );
  };

export default BarGraphSubjectWise;
